import {createAsyncThunk} from "@reduxjs/toolkit";
import axios, {AxiosError} from "axios";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {setNotFoundError} from "features/model/slice/error/errorSlice";

interface Answer {
    questionId: number;
    answerId: number | number[];
}

interface StudentAnswerRequest {
    testId: number;
    answers: Answer[];
}

export const postStudentAnswer = createAsyncThunk(
    'test/studentAnswer',
    async ({ testId, requestData }: { testId: number | undefined; requestData: StudentAnswerRequest }, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('No token found in localStorage.');
            }
            const { token } = JSON.parse(authToken);

            const response = await axios.post(
                `/api/tests/${testId}/student-answer`,
                requestData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.success) {
                return response.data;
            } else {
                throw new Error('Ошибка сохранения урока.');
            }
        } catch (error) {
            thunkAPI.dispatch(setNotFoundError((error as AxiosError).response!.status));
        }
    }
);
